"use client"

/**
 * Кука casper_media (HttpOnly) для раздачи медиа из /api/** — плеер и <img> не умеют слать
 * Authorization. Синхронизируется с токеном активного аккаунта: вход, смена аккаунта и
 * обновление токена — POST, выход и потеря токена — DELETE. Ошибки не мешают работе:
 * без куки файлы просто не отдаются по прямой ссылке, а следующая смена токена повторит попытку.
 */

let syncedToken: string | null | undefined

export function syncMediaSession(token: string | null): void {
  if (typeof window === "undefined" || typeof fetch !== "function") return
  if (token === syncedToken) return
  syncedToken = token
  const forget = () => {
    if (syncedToken === token) syncedToken = undefined
  }
  try {
    fetch("/api/media/session", {
      method: token ? "POST" : "DELETE",
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      credentials: "same-origin",
      cache: "no-store",
      keepalive: true,
    }).then(res => { if (!res.ok) forget() }, forget)
  } catch {
    forget()
  }
}

export function resetMediaSessionForTests(): void {
  syncedToken = undefined
}
